import { PreciseDosage } from '../types';

export const formatPreciseDosage = (preciseDosage: PreciseDosage): string => {
   return `${preciseDosage.frequency}x${preciseDosage.portion} ${preciseDosage.unit}`;
};

export const hasDailyDose = (preciseDosage: PreciseDosage | undefined): boolean => {
   return Boolean(preciseDosage?.frequency && preciseDosage.portion);
};
